import { render } from "./AdminHired.vue?vue&type=template&id=2ff84c45&scoped=true"
import script from "./AdminHired.vue?vue&type=script&lang=js"
export * from "./AdminHired.vue?vue&type=script&lang=js"

import "./AdminHired.vue?vue&type=style&index=0&id=2ff84c45&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff84c45"]])

export default __exports__